import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { TopMenuComponent } from './top-menu';
import { FooterComponent } from './footer';
import { RouterModule } from '@angular/router';
import { homeRoutes } from './home.routing';
import { SideNavComponent } from './side-nav/side-nav.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { VideoModule } from '../video/video.module';
import { ApportisCommonModule } from '../common';
import { ThemeModule } from '../theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgImageSliderModule } from 'ng-image-slider';
import { MultilevelMenuService, NgMaterialMultilevelMenuModule } from 'ng-material-multilevel-menu';

@NgModule({
    declarations: [
        HomeComponent,
        TopMenuComponent,
        FooterComponent,
        SideNavComponent
    ],
    imports: [
        CommonModule
        , RouterModule
        , RouterModule.forChild(homeRoutes)
        , MatSlideToggleModule
        , FormsModule
        , VideoModule
        , ApportisCommonModule
        , ThemeModule
        , NgbModule
        , NgImageSliderModule
        , NgMaterialMultilevelMenuModule
    ],
    exports: [],
    providers: [MultilevelMenuService],
})
export class HomeModule { }
